import { useState, useEffect, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { viewLeadDetailsModified } from 'services/lead/leadServices';
import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';

export function useLeadDetails() {
  const [leadDetails, setLeadDetails] = useState(null);
  const { id } = useParams();
  const history = useHistory();
  const { addToast } = useToast();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (id) {
      isInitialLoad.current = true;
      loadLeadDetails();
    }
  }, [id]);

  const handleUnauthorizedAccess = () => {
    addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'Access restricted. The requested lead does not exist.');
    if (window.history.length > 1) {
      history.goBack();
    } else {
      history.replace('/leads');
    }
  };

  const loadLeadDetails = (_id) => {
    let lead_sk = id || _id;
    if ((id || _id).startsWith('case')) {
      lead_sk = (id || _id).split('#')[1];
    }
    viewLeadDetailsModified({ sk: lead_sk })
      .then((response) => {
        let dat = response.data?.leads;

        if (!dat || !dat.is_lead) {
          if (isInitialLoad.current) {
            handleUnauthorizedAccess();
          }
          return;
        }

        isInitialLoad.current = false;
        dat.client_details = dat.main_client;
        dat.team_member = dat.lead_assign_to;
        dat.relations = [...(dat?.contact || []), ...(dat?.relations || [])];
        setLeadDetails(dat);
      })
      .catch((error) => {
        console.log(error);
        if (isInitialLoad.current) {
          handleUnauthorizedAccess();
        }
      });
  };

  const clearData = () => setLeadDetails(null);

  return {
    leadDetails,
    loadLeadDetails,
    clearData,
  };
}
